import { QueueRef, TaskBasic } from '@/tracker/types';

/** Очередь, в которой больше всего задач; при равенстве — та, что встретилась раньше. null — задач нет */
export const mostCommonQueue = (tasks: TaskBasic[]): QueueRef | null => {
  const counts = new Map<string, number>();
  let best: QueueRef | null = null;
  let bestCount = 0;

  for (const { queue } of tasks) {
    const count = (counts.get(queue.key) ?? 0) + 1;

    counts.set(queue.key, count);

    if (count > bestCount) {
      best = { key: queue.key, name: queue.name };
      bestCount = count;
    }
  }

  return best;
};
